<template>
	<div class="so-wrap-content">
		<div class="so-wrap-components">
			<div class="so-wrap-component">
				<div class="so-hover-div" @mouseenter="showText = 'app'" @mouseleave="showText = null">
					<div class="so-wrap-icon">
						<Hexagon :type="'vitPar'" :position="'1'" />
						<Hexagon :type="'quest'" :position="'2'" />
						<Hexagon :type="'sensor'" :position="'3'" />
						<Hexagon :type="'event'" :position="'4'" />
						<Hexagon :type="'appSec'" :position="'5'" />
						<i class="fas fa-mobile-alt so-interactive-icon" @click="scrollTo($event, '#Smartphone')"></i>
					</div>
				</div>
				<div class="so-component-description">
					<!-- <p class="so-component-title so-horizontal-layout">{{ $t('soAppTitle') }}</p> -->
				</div>
			</div>
			<div class="so-wrap-component">
				<div class="so-hover-div" @mouseenter="showText = 'con1'" @mouseleave="showText = null">
					<div class="so-wrap-icon">
						<Hexagon :type="'conSec'" :position="'3'" />
						<i
							class="fas fa-arrows-alt-h so-interactive-icon so-horizontal-layout"
							@click="scrollTo($event, '#Connection')"
						></i>
						<i
							class="fas fa-arrows-alt-v so-interactive-icon so-vertical-layout"
							@click="scrollTo($event, '#Connection')"
						></i>
					</div>
				</div>
				<div class="so-component-description">
					<!-- <p class="so-component-title ">{{ $t('soConTitle') }}</p> -->
				</div>
			</div>
			<div class="so-wrap-component">
				<div class="so-hover-div" @mouseenter="showText = 'data'" @mouseleave="showText = null">
					<div class="so-wrap-icon">
						<Hexagon :type="'dataSec'" :position="'2'" />
						<Hexagon :type="'operation'" :position="'3'" />
						<Hexagon :type="'accCont'" :position="'4'" />
						<i class="fas fa-database so-interactive-icon" @click="scrollTo($event, '#Database')"></i>
					</div>
				</div>
				<div class="so-component-description">
					<!-- <p class="so-component-title so-horizontal-layout">{{ $t('soDataTitle') }}</p> -->
				</div>
			</div>
			<div class="so-wrap-component">
				<div class="so-hover-div" @mouseenter="showText = 'con2'" @mouseleave="showText = null">
					<div class="so-wrap-icon">
						<Hexagon :type="'conSec'" :position="'3'" />
						<i
							class="fas fa-arrows-alt-h so-interactive-icon so-horizontal-layout"
							@click="scrollTo($event, '#Connection')"
						></i>
						<i
							class="fas fa-arrows-alt-v so-interactive-icon so-vertical-layout"
							@click="scrollTo($event, '#Connection')"
						></i>
					</div>
				</div>
				<div class="so-component-description">
					<!-- <p class="so-component-title ">{{ $t('soConTitle') }}</p> -->
				</div>
			</div>
			<div class="so-wrap-component">
				<div class="so-hover-div" @mouseenter="showText = 'client'" @mouseleave="showText = null">
					<div class="so-wrap-icon">
						<Hexagon :parent="'Client'" :type="'clientSec'" :position="'1-5'" />
						<Hexagon :parent="'Client'" :type="'config'" :position="'2-5'" />
						<Hexagon :parent="'Client'" :type="'dataVis'" :position="'3-5'" />
						<Hexagon :parent="'Client'" :type="'pracTalk'" :position="'4-5'" />
						<i class="fas fa-desktop so-interactive-icon" @click="scrollTo($event, '#Client')"></i>
					</div>
				</div>
				<div class="so-component-description">
					<!-- <p class="so-component-title so-horizontal-layout">{{ $t('soClientTitle') }}</p> -->
				</div>
			</div>
		</div>
		<div class="so-component-text">
			<p v-if="showText == 'app'" class="so-component-title" v-html="translations.soAppTitle"></p>
			<p v-if="showText == 'app'" class="so-app-text" v-html="translations.soAppShortText"></p>
			<p v-if="showText == 'con1'" class="so-component-title" v-html="translations.soConTitle"></p>
			<p v-if="showText == 'con1'" class="so-con-1-text" v-html="translations.soConShortText1"></p>
			<p v-if="showText == 'data'" class="so-component-title" v-html="translations.soDataTitle"></p>
			<p v-if="showText == 'data'" class="so-data-text" v-html="translations.soDataShortText"></p>
			<p v-if="showText == 'con2'" class="so-component-title" v-html="translations.soConTitle"></p>
			<p v-if="showText == 'con2'" class="so-con-2-text" v-html="translations.soConShortText2"></p>
			<p v-if="showText == 'client'" class="so-component-title" v-html="translations.soClientTitle"></p>
			<p v-if="showText == 'client'" class="so-client-text" v-html="translations.soClientShortText"></p>
			<p v-if="!showText" class="so-component-title" v-html="translations.soSystemTitle"></p>
			<p v-if="!showText" class="so-client-text" v-html="translations.soSystemShortText"></p>
		</div>
	</div>
</template>

<script>
import Hexagon from './Hexagon.vue';
import i18n from '@/translations/i18n';
export default {
	name: 'SystemOverview',
	components: {
		Hexagon,
	},
	data() {
		return {
			showText: null,
			lastTarget: null,
			translations: {},
		};
	},
	computed: {
		computedTranslations: function() {
			return {
				soAppTitle: this.$t('soAppTitle'),
				soAppShortText: this.$t('soAppShortText'),
				soConTitle: this.$t('soConTitle'),
				soConShortText1: this.$t('soConShortText1'),
				soConShortText2: this.$t('soConShortText2'),
				soDataTitle: this.$t('soDataTitle'),
				soDataShortText: this.$t('soDataShortText'),
				soClientTitle: this.$t('soClientTitle'),
				soClientShortText: this.$t('soClientShortText'),
				soSystemTitle: this.$t('soSystemTitle'),
				soSystemShortText: this.$t('soSystemShortText'),
			};
		},
	},
	created() {
		this.translations = this.computedTranslations;
		this.hyphenateText();
		window.addEventListener('languageChange', this.languageEvent);
	},
	beforeDestroy() {
		window.removeEventListener('languageChange', this.languageEvent);
	},
	methods: {
		languageEvent() {
			if (i18n.locale !== 'en') this.hyphenateText();
			else this.translations = this.computedTranslations;
		},
		hyphenateText() {
			let that = this;
			this.$global.getHyphenation(this.computedTranslations, function(data) {
				that.translations = data;
			});
		},
		scrollTo(e, dest) {
			if (this.$global.isMobile()) {
				if (this.lastTarget == e.target) document.querySelector(dest).scrollIntoView({ behavior: 'smooth' });
				else this.lastTarget = e.target;
			} else {
				document.querySelector(dest).scrollIntoView({ behavior: 'smooth' });
			}
		},
	},
};
</script>

<style scoped>
.so-wrap-content {
	height: 500px;
	width: 100%;
	padding: 50px 87px 0px 70px;
	box-sizing: border-box;
}

.so-wrap-components {
	display: block;
	width: 100%;
	margin: 0px;
}

.so-wrap-component {
	vertical-align: top;
	display: inline-block;
	width: calc((100% - 40px) / 5);
}

.so-hover-div {
	height: fit-content;
	padding-top: 70px;
}

.so-component-title {
	margin: 25px 0px 10px 0px;
	font-size: 20px;
	color: var(--main-color-highlight);
	/* font-weight: bold; */
}

.so-component-text {
	/* display: none; */
	margin: 15px 0px;
	font-size: 20px;
	color: var(--main-color-text-light);
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
	-webkit-animation-name: fadeIn;
	animation-name: fadeIn;
	text-align: justify;
}

.so-wrap-icon {
	width: 130px;
	height: 130px;
	padding: 10px;
	border-radius: 50%;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	margin: 5px;
	position: relative;
	cursor: pointer;
}

.so-wrap-icon:hover {
	background-color: var(--main-color-dark);
	box-shadow: 0px 0px 10px 10px #ffffffcc;
}

.so-hover-div:hover .hg-wrap-content {
	display: block;
}

.so-hover-div:hover .so-wrap-icon {
	background-color: var(--main-color-dark);
	box-shadow: 0px 0px 10px 10px #ffffffcc;
}

.so-hover-div:hover .so-component-text {
	display: block;
}

.so-hover-div:hover .so-wrap-icon i {
	color: var(--main-color-text-light);
	-webkit-text-stroke: 2px var(--main-color-text-dark);
}

.so-interactive-icon {
	color: var(--main-color-text-light);
	font-size: 100px;
	-webkit-text-stroke: 2px var(--main-color-text-dark);
}

.so-wrap-icon:hover i {
	color: var(--main-color-text-light);
	-webkit-text-stroke: 2px var(--main-color-text-dark);
}

.so-wrap-icon:hover .hg-wrap-content {
	display: block;
	cursor: pointer;
}

.so-horizontal-layout {
	display: block;
}

.so-vertical-layout {
	display: none;
}

@keyframes fadeIn {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

@-webkit-keyframes fadeIn {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

@media screen and (max-width: 900px) {
	.so-component-title {
		width: fit-content;
		margin: 25px 0px 10px 0px;
		font-size: 20px;
		text-align: center;
	}

	.so-component-text {
		margin: 15px 0px;
		font-size: 17px;
	}

	.so-wrap-icon {
		width: 100px;
		height: 100px;
		padding: 5px;
		position: relative;
	}

	.so-interactive-icon {
		font-size: 70px;
	}

	.so-horizontal-layout {
		display: block;
	}

	.so-vertical-layout {
		display: none;
	}
}

@media screen and (max-width: 700px) {
	.so-wrap-content {
		margin-top: 30px;
		height: fit-content;
		width: 100%;
		padding: 20px 27px 0px 10px;
		box-sizing: border-box;
		text-align: start;
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}

	.so-wrap-components {
		display: inline-block;
		width: fit-content;
		margin: 0px;
	}

	.so-wrap-component {
		display: block;
		width: 33vw;
	}

	.so-hover-div {
		height: fit-content;
		padding: 10px 70px 10px 0px;
	}

	.so-wrap-icon {
		width: 100px;
		height: 100px;
		padding: 5px;
		position: relative;
	}

	.so-interactive-icon {
		font-size: 70px;
	}

	.so-component-title {
		font-size: 25px;
		margin: 0px;
	}

	.so-component-text {
		width: calc(67vw - 60px);
		height: 100%;
	}

	.so-horizontal-layout {
		display: none;
	}

	.so-vertical-layout {
		display: block;
	}
}

@media (pointer: none), (pointer: coarse) {
	.so-wrap-content {
		margin-top: 30px;
		height: fit-content;
		width: 100%;
		padding: 10px 17px 0px 10px;
		box-sizing: border-box;
		text-align: start;
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}

	.so-wrap-components {
		display: inline-block;
		width: fit-content;
		margin: 0px;
	}

	.so-wrap-component {
		display: block;
		width: 33vw;
		margin: 10px 0px;
	}

	.so-hover-div {
		height: fit-content;
		padding: 10px 70px 10px 0px;
	}

	.so-wrap-icon {
		width: 60px;
		height: 60px;
		padding: 5px;
		position: relative;
	}

	.so-interactive-icon {
		font-size: 40px;
	}

	.so-component-title {
		font-size: 17px;
		margin: 0px;
	}

	.so-component-text {
		width: calc(67vw - 30px);
		height: 100%;
	}

	.so-horizontal-layout {
		display: none;
	}

	.so-vertical-layout {
		display: block;
	}
}
</style>
